import { api } from '@/src/shared/lib/api'

export async function videoStoryQueueNextGet<ApiResponse>(count: number = 1) {
  const url = api.appURL('video_story_queue/next')
  url.searchParams.append('count', count.toString())
  const response = await api.get<ApiResponse>(url, {})
  return api.parseRespone<ApiResponse>(response)
}
